export class Produto
{
    nomeComercial: string;
    registroANS: string;
    tipoContratacao: string;
    situacaoANS: string;

    constructor() {
        
        this.nomeComercial = 'HIe';
        this.registroANS = 'EHAEE';
        this.tipoContratacao = 'HEAUIhe';
        this.situacaoANS = 'aeuahea';
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/resultado-pesquisa/produto.ts
 **/